export * from './ubiMenuItem.component';



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/theme/components/ubiMenu/components/ubiMenuItem/index.ts